module.exports = __webpack_public_path__ + "static/media/13_2.d2e32a7e.jpg";